<template>
  <div class="docs">
    <div class="col-md-12 jumbotron my-3 p-3">
      <p class="header"><strong>POINTS</strong></p>
      <div class="m-0 p-0">
        <p class="header">Total Points: {{ customerPoints.points }}</p>
        <p class=" m-0 p-0">Add Points</p>
        <!-- <div class="col-md-6 m-0 p-0 mt-2">
          <p class="m-0 p-0 labels">Description with booking ID</p>
          <input
            v-model="description"
            class="form-control"
            type="text"
            placeholder="eg. cx created a lead- L20B2145"
          />
        </div> -->
        <div class="col-md-6 m-0 p-0 mt-2">
          <p class="m-0 p-0 labels">Points</p>
          <input v-model="point" class="form-control" type="number" placeholder="eg. 4500" />
        </div>
        <button @click="addPoints" style="font-size:13px" class="btn btn-secondary my-2">
          ADD POINT
        </button>
      </div>
    </div>
    <div class="col-md-12 jumbotron m-0 p-3">
      <p class="header"><strong>PENALTY</strong></p>
      <div class="jumbotron m-0 p-0">
        <p class="header">Total Penalty: {{ customerDetail.penaltyCharge }}</p>
        <!-- <p class=" m-0 p-0">Add Points</p>
          <div class="col-md-6 m-0 p-0 mt-2">
            <p class="m-0 p-0 labels">Description with booking ID</p>
            <input class="form-control" type="text" placeholder="eg. cx created a lead- L20B2145">
          </div>
          <div class="col-md-6 m-0 p-0 mt-2">
            <p class="m-0 p-0 labels">Points</p>
            <input class="form-control" type="text" placeholder="eg. 4500">
          </div> -->
        <button
          @click="openPenalty"
          style="font-size:13px"
          class="btn btn-secondary my-2"
        >
          ADJUST PENALTY
        </button>
      </div>
    </div>

    <div class="col-md-12 my-3 jumbotron p-3">
      <p class="header"><strong>POINT LEDGER</strong></p>
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Type</th>
            <th scope="col">Value</th>
            <th scope="col">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in pointLedger" :key="index">
            <th scope="row">{{ data.id }}</th>
            <td>{{ data.transactionType }}</td>
            <td>
              <span class="badge badge-primary">{{ data.value }}</span>
            </td>
            <td style="white-space: nowrap;">
              {{ data.createdAt | moment("LLL") }}
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="mt-5 col-md-12 text-center"
        v-if="pointLedger.length == 0 && !makingAJAX"
      >
        <p>We didn't get any data.</p>
      </div>
    </div>

    <div
      id="myModal2"
      class="col-md-12 booking-loading p-0"
      v-if="adjustAmountToggle"
    >
      <!-- booking-loading content -->
      <div class="booking-loading-content text-left col-md-6">
        <div class="row col-md-12 m-0 p-0">
          <div class="mb-3 col-md-4">
            <p class="labels m-0 p-0">Total Penalty</p>
            <input
              type="number"
              class="form-control"
              disabled
              v-model="penalty"
            />
          </div>
          <div class="mb-3 col-md-4">
            <p class="labels m-0 p-0">Waived Off</p>
            <input type="number" class="form-control" v-model="waiveoff" />
          </div>
          <div class="mb-3 col-md-4">
            <p class="labels m-0 p-0">Paid</p>
            <input type="number" class="form-control" v-model="paid" />
          </div>
          <div class="mb-3 col-md-4">
            <p class="labels m-0 p-0">Add Penalty</p>
            <input type="number" class="form-control" v-model="addpenalty" />
          </div>
          <div class="mb-3 col-md-4">
            <p class="labels m-0 p-0">Outstanding</p>
            <input
              type="number"
              disabled
              class="form-control"
              v-model="outstanding"
            />
          </div>
        </div>
        <div class="mb-3 text-right">
          <button
            @click="cancelPenalty"
            class="penalty-button ml-3 py-2"
            style="background-color:white;border:1px solid gray;color:black"
          >
            Cancel
          </button>
          <button @click="savePenalty" class="penalty-button ml-3 py-2">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  data() {
    return {
      penalty: 0,
      waiveoff: 0,
      paid: 0,
      addpenalty: 0,
      adjustAmountToggle: false,
      description:'',
      point:''
    };
  },
  created() {
    this.$store.state.customer_by_number = [];
    this.phone_number = this.$route.params.phone;
    this.cx_id = this.$route.params.cx_id;
    this.currentTab = this.$route.query.tab;
    if (this.phone_number) {
      this.$store.dispatch("get_customer_points", { id: this.cx_id });
    } else {
      this.showModal = true;
    }
    this.$store.dispatch("get_customerData", { id: this.cx_id });
    this.$store.dispatch("get_point_ledger", { id: this.cx_id });

  },
  methods: {
    addPoints(){
      var tnx = ''
      if(this.point<0){
        tnx = 'debit'
      }else{
        tnx = 'credit'
      }
       axios
        .post(
          `https://api.on-track.in/api/addPoints`,
          {
            bookingId: null,
            customer: this.cx_id,
            transactionType: tnx,
            value: this.point,
            createdBy: this.agentName,
            description: this.description
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          let description = `${this.point} points ${tnx}ed for customer ${this.cx_id} by ${this.agentName}`
          this.createAgentActivity(null, description, "Points");
          this.description = ''
          this.point = 0
          this.$store.dispatch("get_customer_points", { id: this.cx_id });
        })
        .catch((error) => {
          if (error.response) {
            this.$toasted.global.my_app_error();
          } else {
            this.$toasted.global.my_app_error();
          }
        });
    },
    openPenalty() {
      this.adjustAmountToggle = true;
      this.penalty = this.customerDetail.penaltyCharge;
    },
    cancelPenalty() {
      this.adjustAmountToggle = false;
      this.penalty = 0;
      this.paid = 0;
      this.waiveoff = 0;
      this.addpenalty = 0;
    },
    savePenalty() {
      this.adjustAmountToggle = false;
      let customerId = this.customerDetail.id;
      axios
        .post(
          `https://api.on-track.in/api/customer/${customerId}`,
          {
            penaltyCharge: this.outstanding,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          let description = 
          "penalty updated from " +
          this.penalty +
          " to " +
          this.outstanding +
          " , waived: " +
          this.waiveoff +
          " , added: " +
          this.addpenalty +
          " , paidAmount: " +
          this.paid +
          " of customer " +
          this.customerDetail.id;
          this.createAgentActivity(null, description, "Penalty");
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch((error) => {
          if (error.response) {
            this.$toasted.global.my_app_error();
          } else {
            this.$toasted.global.my_app_error();
            this.adjustAmountToggle = false;
          }
        });
    },
    createAgentActivity(bookingId, description, type) {
      let bkid = bookingId
      axios
        .post(
          `https://api.on-track.in/api/createActivity`,
          {
            agentId: this.agentID,
            bookingId: bkid,
            name: this.agentName,
            description: description,
            type: type,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("updated.", {
            type: "success",
            position: "bottom-center",
            duration: 2000,
            theme: "bubble",
          });
          this.adjustAmountToggle = false;
        })
        .catch((error) => {
          if (error.response) {
            this.$toasted.global.my_app_error();
            this.adjustAmountToggle = false;
          } else {
            this.$toasted.global.my_app_error();
            this.adjustAmountToggle = false;
          }
        });
    },
  },
  computed: {
    makingAJAX() {
      return this.$store.state.makingAJAX;
    },
    customerPoints() {
      return this.$store.state.customer_points;
    },
    pointLedger() {
      return this.$store.state.point_ledger;
    },
    outstanding() {
      return (
        Number(this.penalty) +
        Number(this.addpenalty) -
        (Number(this.waiveoff) + Number(this.paid))
      );
    },

    bookingDetails() {
      return this.$store.state.booking_by_id;
    },
    agentID() {
      return localStorage.getItem("agent_id");
    },
    agentName() {
      return localStorage.getItem("username");
    },
    customerDetail() {
      return this.$store.state.customer_data;
    },
  },
};
</script>

<style scoped>
.header {
  font-size: 15px;
  color: blue;
}
.labels {
  color: gray;
}
.booking-loading {
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  overflow: hidden;
}

/* booking-loading Content */
.booking-loading-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}
</style>
